import { size as _size } from 'lodash-es';
import { dbEvents } from 'server/database/collections';

export const fetchEventDetails = async eventId => {
	const eventData = await dbEvents.getEventDetails(eventId);
	return !_size(eventData) ? {} : eventData;
};
